import { Component, type ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  failed: boolean;
}

export default class DebugBoundary extends Component<Props, State> {
  state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: { componentStack?: string }) {
    console.error(
      "[AutoSavePdfHost] crashed with:",
      error?.message ?? error,
      "\nstack:",
      error?.stack,
      "\nreact stack:",
      info?.componentStack,
    );
  }

  render() {
    if (this.state.failed) return null;
    return this.props.children;
  }
}
